<template>
  <div class="row">
    <div class="col-lg-12">
      <!-- <loading
        loader="spinner"
        :height="70"
        :width="70"
        color="#00f2c3"
        background-color="#6c757d"
        transition="fade"
        :active="isLoading"
        :is-full-page="false"
      ></loading> -->
      <div class="row">
        <div class="col-lg-12">
          <p style="font-size: 20px">
            {{ luxname }} : Last Updated {{ lastupdate }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg">
              <!-- mini card section -->
              <div class="row">
                <div class="col-lg d-flex">
                  <card class="card-icon" style="padding: 0px">
                    <div class="row">
                      <div class="" style="position: absolute; left: 10px">
                        <img :src="connectionstatusIcon" width="40px;" />
                      </div>
                      <div
                        class="col-lg text-right"
                        style="font-size: 10px; color: #6a6a73"
                      >
                        <p
                          class="card-category"
                          style="font-size: 10px; color: #6a6a73"
                        >
                          <!-- {{ connectionstatusTitle }} -->
                          Connection <br />
                          Status
                        </p>

                        <h4 class="card-title" style="font-size: 15px">
                          {{ connectionstatus }}
                        </h4>
                      </div>
                    </div>
                    <!-- <div class="row bottom-line">
                      <div class="col-lg">
                        <p>Node RSSI</p>
                      </div>
                      <div class="col-lg-5 text-right" style="color: #ffffff">
                        : {{ noderssi }}
                      </div>
                    </div> -->
                    <div class="row bottom-line">
                      <div class="col-lg">
                        <p>Gateway RSSI</p>
                      </div>
                      <div class="col-lg-5 text-right" style="color: #ffffff">
                        : {{ gatewayrssi }}
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg d-flex">
                  <card class="card-icon" style="padding: 0px">
                    <div class="row">
                      <div class="" style="position: absolute; left: 10px">
                        <img :src="luxlevelIcon" width="40px;" />
                      </div>
                      <div
                        class="col-lg text-right"
                        style="font-size: 10px; color: #6a6a73"
                      >
                        <p
                          class="card-category"
                          style="font-size: 10px; color: #6a6a73"
                        >
                          LUX <br />Level
                        </p>

                        <h4 class="card-title" style="font-size: 15px">
                          {{ luxlevel }}
                        </h4>
                      </div>
                    </div>
                    <div class="row bottom-line">
                      <div class="col-lg">
                        <p>Value (lx)</p>
                      </div>
                      <div class="col-lg-5 text-right" style="color: #ffffff">
                        : {{ luxvalue }}
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg d-flex">
                  <card
                    class="card-icon"
                    style="padding: 0px; min-height: 120px"
                  >
                    <div class="row">
                      <div class="" style="position: absolute; left: 10px">
                        <img :src="transmissionintervalIcon" width="40px;" />
                      </div>
                      <div
                        class="col-lg text-right"
                        style="font-size: 10px; color: #6a6a73"
                      >
                        <p
                          class="card-category"
                          style="font-size: 10px; color: #6a6a73"
                        >
                          Transmission <br />Interval
                          <!-- {{ transmissionintervalTitle }} -->
                        </p>

                        <h4 class="card-title" style="font-size: 15px">
                          {{ transmissioninterval }}
                        </h4>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg d-flex">
                  <card class="card-icon" style="padding: 0px">
                    <div class="row">
                      <div class="" style="position: absolute; left: 10px">
                        <img :src="batterylevelIcon" width="40px;" />
                      </div>
                      <div
                        class="col-lg text-right"
                        style="font-size: 10px; color: #6a6a73"
                      >
                        <p
                          class="card-category"
                          style="font-size: 10px; color: #6a6a73"
                        >
                          {{ batterylevelTitle }}
                        </p>

                        <h4 class="card-title" style="font-size: 15px">
                          {{ batterylevel }}
                        </h4>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 d-flex" style="height: 290px">
          <div id="map" class="map">
            <l-map
              v-model="center"
              ref="map"
              id="toto"
              style="height: 285px"
              :zoom="8"
              :center="center"
              :bounds="devBounds"
              class="sidebar-map"
              :options="{ scrollWheelZoom: false, zoomControl: true }"
            >
              <!-- :bounds="devBounds" -->
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>

              <l-marker
                v-for="marker in markers"
                :icon="markerIcon()"
                :key="marker.addMarker"
                :lat-lng="marker.location"
                ref="markersRef"
              >
                <l-tooltip :content="marker.deviceName" />
              </l-marker>
            </l-map>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 d-flex">
          <!-- <loading
            loader="spinner"
            :height="70"
            :width="70"
            color="#00f2c3"
            background-color="#6c757d"
            transition="fade"
            :active="isChartLoading"
            :is-full-page="false"
          ></loading> -->
          <card>
            <div class="row">
              <div
                class="col-lg"
                style="
                  position: relative;
                  max-width: 200px;
                  min-width: 200px;
                  left: 50px;
                "
              >
                <img src="@/assets/img/lux color chart.png" width="300px" />
                <div :style="rigtharrow">
                  <i
                    style="color: #ffd811; font-size: 50px; position: absolute"
                    class="fa fa-caret-right"
                    aria-hidden="true"
                  ></i>
                </div>
                <div :style="leftarrow">
                  <i
                    style="color: #ffd811; font-size: 50px; position: absolute"
                    class="fa fa-caret-left"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>

              <div class="col-lg" style="padding-left: 15%; padding-top: 140px">
                <p style="color: #ffffff; font-size: 20px">
                  Current Lux Level (lx)
                </p>
                <p style="color: #1faeca; font-size: 30px">
                  {{ currentlux }}
                </p>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-8 d-flex">
          <!-- lux level graph -->

          <card type="card-chart">
            <loading
              loader="spinner"
              :height="70"
              :width="70"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isChartLoading"
              :is-full-page="false"
            ></loading>
            <div class="row">
              <div class="col-lg text-center">
                <p style="font-size: 18px; color: #ffffff">Lux Level Graph</p>
                <p style="font-size: 15px; color: #ffffff">
                  {{ filter.date1 }} - {{ filter.date2 }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg text-center">
                <base-button
                  class="btn-round btn-success"
                  @click="modals.date = true"
                  >Select Date</base-button
                >
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <line-chart
                  v-if="lineChart1.loaded"
                  :chart-data="lineChart1.chartData"
                  :gradient-colors="lineChart1.gradientColors"
                  :gradient-stops="lineChart1.gradientStops"
                  :extra-options="lineChart1.extraOptions"
                  :height="250"
                ></line-chart>
              </div>
            </div>
          </card>
        </div>
      </div>

      <modal :show.sync="modals.date" type="medium">
        <template slot="header">
          <h3 class="modal-title">Choose date range</h3>
        </template>
        <div class="row">
          <div class="col-lg">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="right"
              unlink-panels
              start-placeholder="Start date"
              end-placeholder="End date"
            ></el-date-picker>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div class="row">
          <div class="col-lg text-center">
            <base-button class="btn-success btn-round" @click="saveDate()"
              >Save</base-button
            >
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
// import StatsCard from "src/components/Cards/StatsCard";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LLayerGroup,
  LTooltip,
  LControl,
} from "vue2-leaflet";
import { latLngBounds, latLng } from "leaflet";
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { Modal } from "src/components";
import { DatePicker } from "element-ui";
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    // StatsCard,
    LMap,
    LTileLayer,
    LMarker,
    LLayerGroup,
    LPopup,
    LControl,
    LTooltip,
    LineChart,
    Modal,
    [DatePicker.name]: DatePicker,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      isChartLoading: false,
      luxname: "-",
      lastupdate: "- Minutes Ago",

      connectionstatus: "-",
      connectionstatusTitle: "Connection Status",
      connectionstatusIcon: require("@/assets/img/Connection Icon V2.png"),

      luxlevel: "-",
      luxlevelTitle: "LUX Level",
      luxlevelIcon: require("@/assets/img/Icons copy.png"),

      transmissioninterval: "- Min",
      transmissionintervalTitle: "Transmission Interval",
      transmissionintervalIcon: require("@/assets/img/Time Icon.png"),

      batterylevel: "-%",
      batterylevelTitle: "Battery Level",
      batterylevelIcon: require("@/assets/img/Battery Icon.png"),

      noderssi: "-",
      gatewayrssi: "-",
      luxvalue: "-",

      //   top
      // rigtharrow: "position: absolute;left: 15px; top: 30px;",
      // leftarrow: "position: absolute;right: 35px; top: 30px;",

      // middle
      //   rigtharrow: "position: absolute;left: 15px; top: 150px;",
      //   leftarrow: "position: absolute;right: 35px; top: 150px;",

      // bottom
      rigtharrow: "position: absolute;left: 15px; top: 280px;",
      leftarrow: "position: absolute;right: 35px; top: 280px;",

      currentlux: 0,
      zoom: 18,
      center: L.latLng(3.15464, 101.718635),
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors ',
      markers: [
        {
          location: L.latLng(2.921182, 101.636671),
        },
      ],
      devBounds: [[2.921182, 101.636671]],

      filter: {
        date1: "-",
        date2: "-",
      },
      lineChart1: {
        chartData: {
          labels: [0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
      modals: {
        date: false,
      },
      dateRange: "",
      deviceid: "",
      devicetoken: "",
      start: "",
      end: "",
    };
  },
  created() {
    console.log(this.$route.params.deviceid);
    console.log(this.$route.params.start);
    console.log(this.$route.params.end);
    console.log(this.$route.params.devicetoken)
    this.devicetoken = this.$route.params.devicetoken;
    this.deviceid = this.$route.params.deviceid;
    this.dateRange = [moment().subtract(24, "hours"), moment()];
    // this.start = this.$route.params.start;
    // this.end = this.$route.params.end;

    this.getLuxData();
    this.getNonChartData();
    this.getLuxDetail();
    this.getDeviceDetails();
  },
  methods: {
    getNonChartData() {
      this.$http
        .get(":8001/api/v1/insight/device/lux/latestdata/" + this.devicetoken)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            
              this.lastupdate = moment(response.Timestamp).fromNow();

              let startTime = moment(response.Timestamp)
              let end = moment()
              var duration = moment.duration(end.diff(startTime));
              var hours = duration.asHours();

              if(hours > 1){
                this.connectionstatus = "OFFLINE";
              } else {
                this.connectionstatus = "ONLINE";
              }
              
              this.noderssi = "-";
              this.gatewayrssi = response.RssiGW;
              
              this.luxvalue = response.LuxValue;

               if (this.luxvalue > 11000) {
                this.luxlevel = "BRIGHT";
                this.rigtharrow = "position: absolute;left: 15px; top: 30px;";
                this.leftarrow = "position: absolute;right: 35px; top: 30px;";
              } else if (this.luxvalue >= 11 && this.luxvalue <= 10999) {
                this.luxlevel = "CLOUDY";
                this.rigtharrow = "position: absolute;left: 15px; top: 150px;";
                this.leftarrow = "position: absolute;right: 35px; top: 150px;";
              } else {
                this.luxlevel = "DARK";
                this.rigtharrow = "position: absolute;left: 15px; top: 280px;";
                this.leftarrow = "position: absolute;right: 35px; top: 280px;";
              }
              this.currentlux = response.LuxValue;
              // this.transmissioninterval = "-";
              this.batterylevel = response.LastBatteryValue;
           
          }
        });
    },
    markerIcon() {
      if (this.connectionstatus == "ONLINE") {
        return L.icon({
          iconSize: [30, 30], // size of the icon
          iconUrl: require("@/assets/img/LUX map icon online.png"),
          // iconUrl: require("@/assets/img/icon_on.png"),
          // iconSize: [30, 35], // size of the icon
          // shadowUrl: require("@/assets/img/marker-shadow.png"),
          iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
          // shadowAnchor: [30, 30], // the same for the shadow
          // shadowSize: [30, 30],
          popupAnchor: [-3, -76],
        });
      }

      if (this.connectionstatus == "OFFLINE") {
        return L.icon({
          iconSize: [30, 30], // size of the icon
          iconUrl: require("@/assets/img/lux map icon offline.png"),
          // iconUrl: require("@/assets/img/icon_on.png"),
          // iconSize: [30, 35], // size of the icon
          // shadowUrl: require("@/assets/img/marker-shadow.png"),
          iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
          // shadowAnchor: [30, 30], // the same for the shadow
          // shadowSize: [30, 30],
          popupAnchor: [-3, -76],
        });
      }
    },
    getLuxDetail() {
      let payload = {
        devicelist: [this.devicetoken],
      };
      this.$http
        .post(":8001/api/v1/telemetry/device/status/beta/lights", payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
          }
        });
    },
    getDeviceDetails() {
      let deviceid = this.$route.params.deviceid;
      this.deviceID = deviceid;

      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/device/" + deviceid)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            // console.log(res.message);
          } else {
            console.log("DEVICE_INFO: ", res.message);
            let response = res.message;

            this.luxname = response.deviceinfo[0].devicename;
            this.markers = [
              {
                location: L.latLng(
                  response.deviceinfo[0].lat,
                  response.deviceinfo[0].lon
                ),
              },
            ];

            this.devBounds = [
              [response.deviceinfo[0].lat, response.deviceinfo[0].lon],
            ];

            for (var i = 0; i < response.device_attributes.length; i++) {
              if (
                response.device_attributes[i].key == "LUX_TRANSMIT_INTERVAL"
              ) {
                this.transmissioninterval =
                  response.device_attributes[i].value + " Min";
              }
            }

            // this.getLuxData();
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    saveDate() {
      // console.log(this.dateRange);
      this.dateRange = [moment(this.dateRange[0]), moment(this.dateRange[1])];
      // this.start = moment(this.dateRange[0]).unix();
      // this.end = moment(this.dateRange[1]).unix();
      this.getLuxData();
      this.modals.date = false;
    },
    getLuxData() {
      this.isChartLoading = true;
      this.lineChart1.loaded = false;
      console.log(this.dateRange);
      // console.log(this.end);
      console.log(this.devicetoken);
      let s = moment(this.dateRange[0]).format("YYYY-MM-DD HH:mm");
      let e = moment(this.dateRange[1]).format("YYYY-MM-DD HH:mm");
      console.log(s, e);
      // console.log(moment(this.dateRange[0]).utc().format("YYYY-MM-DD hh:mm a"))
      // console.log(moment(this.dateRange[1]).utc().format("YYYY-MM-DD hh:mm a"))
      let a = moment(s).unix();
      let b = moment(e).unix();
      console.log(a, b);
      this.$http
        .get(
          ":8001/api/v1/insight/device/lux/" +
            this.devicetoken +
            // "e1dddcd9cd9dd5ce1ed34d35" +
            "/" +
            // s +
            a +
            "/" +
            // e
            b
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            if (response.length == 0) {
              console.log("woi");
              this.isLoading = false;
            }
            if (response.length != 0) {
              // assign chart data
              let data = [];
              let timestamp = [];
              for (var i = 0; i < response.length; i++) {
                data.push(response[i].LuxValue);
                timestamp.push(
                  moment(response[i].Timestamp)
                    .add(8, "hours")
                    .format("YYYY-MM-DD hh:mm a")
                );
              }

              this.lineChart1 = {
                chartData: {
                  labels: timestamp,
                  datasets: [
                    {
                      label: "Data",
                      fill: true,
                      borderColor: config.colors.primary,
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      pointBackgroundColor: config.colors.primary,
                      pointBorderColor: "rgba(255,255,255,0)",
                      pointHoverBackgroundColor: "#be55ed",
                      pointBorderWidth: 20,
                      pointHoverRadius: 4,
                      pointHoverBorderWidth: 15,
                      pointRadius: 4,
                      data: data,
                    },
                  ],
                },
                extraOptions: chartConfigs.purpleChartOptions,
                gradientColors: config.colors.primaryGradient,
                gradientStops: [1, 0.4, 0],
                loaded: true,
              };

              // hmm

              // this.lastupdate = moment(response[response.length - 1].Timestamp)
              //   .add(8, "hours")
              //   .fromNow();

              // let start = moment(response[response.length - 1].Timestamp).add(
              //   8,
              //   "hours"
              // );
              // let end = moment();
              // console.log(start, end);
              // var duration = end.diff(start, "hours");
              // console.log(duration);
              // this.connectionstatus = duration <= 1 ? "ONLINE" : "OFFLINE";
              // this.noderssi = "N/A";
              // this.gatewayrssi = response[response.length - 1].GatewayRssi;

              // this.luxvalue = response[response.length - 1].LuxValue;
              // if (this.luxvalue > 11000) {
              //   this.luxlevel = "BRIGHT";
              //   this.rigtharrow = "position: absolute;left: 15px; top: 30px;";
              //   this.leftarrow = "position: absolute;right: 35px; top: 30px;";
              // } else if (this.luxvalue >= 11 && this.luxvalue <= 10999) {
              //   this.luxlevel = "CLOUDY";
              //   this.rigtharrow = "position: absolute;left: 15px; top: 150px;";
              //   this.leftarrow = "position: absolute;right: 35px; top: 150px;";
              // } else {
              //   this.luxlevel = "DARK";
              //   this.rigtharrow = "position: absolute;left: 15px; top: 280px;";
              //   this.leftarrow = "position: absolute;right: 35px; top: 280px;";
              // }

              // this.batterylevel =
              //   response[response.length - 1].LastBatteryValue + "%";

              // this.currentlux = response[response.length - 1].LuxValue;

              this.isChartLoading = false;
            }
            // console.log(this.isLoading)
            // this.isLoading = false;
          }
        })
        .catch((err) => {
          this.isChartLoading = false;
        });
    },
  },
  watch: {
    dateRange() {
      console.log(this.dateRange);
      this.filter.date1 = moment(this.dateRange[0]).format(
        "YYYY/MM/DD hh:mm a"
      );
      this.filter.date2 = moment(this.dateRange[1]).format(
        "YYYY/MM/DD hh:mm a"
      );
      console.log(this.filter.date1, this.filter.date2);
    },
  },
};
</script>

<style></style>
